module.exports = __webpack_public_path__ + "static/img/联系客服@3x.15cc243.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/联系客服@3x.png
// module id = 316
// module chunks = 363 364